<template>
    <div class="competencies" v-if="competencies && simulation && ratingOptions">
        <el-table class="table-responsive table-flush"
                :show-header="false"
                :data="competencies">

            <el-table-column>
                <template v-slot="{row}">

                    <h4 class="mb-0">
                        {{ competencyName(row) }}
                    </h4>
                    <div v-if="row.domain">
                        <badge rounded :type="row.domain.color" class="mt-1">
                            {{ competencyDomainName(row) }}
                        </badge>
                    </div>
                    <div class="mt-2">
                        <small class="description">{{ competencyDescription(simulation, row.id) }}</small>
                    </div>

                </template>
            </el-table-column>

            <el-table-column align="right" class-name="rating">
                <template v-slot="{row}">

                    <rating
                        :title="competencyName(row)"
                        :options="ratingOptions"
                        :value="ratings[row.id]"
                        @input="ratingChange(row.id, $event)"
                        :has-comment="true"
                        :comment="comments[row.id]"
                        @comment-change="commentChange(row.id, $event)"
                    >
                    </rating>

                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import Rating from './RatingEdit'

    export default {

        components: {
            Rating
        },

        props: {

            num: {
                type: Number,
            },

            simulation: {
                type: Object,
            },

            registration: {
                type: Object,
            },

            ratingOptions: {
                type: Array,
            },
        },

        data() {
            return {
                ratings: null,
                comments: null,
            }
        },

        watch: {

            simulation: {
                immediate: true,
                handler(simulation) {

                    this.ratings = this.competencies.reduce((cumulated, competency) => {
                        cumulated[competency.id] = simulation.state.competencies && simulation.state.competencies[this.simulationRole] && simulation.state.competencies[this.simulationRole][competency.id]
                            ? simulation.state.competencies[this.simulationRole][competency.id]
                            : -1
                        return cumulated
                    }, {})

                    this.comments = this.competencies.reduce((cumulated, competency) => {
                        cumulated[competency.id] = simulation.state.competency_comments && simulation.state.competency_comments[this.simulationRole] && simulation.state.competency_comments[this.simulationRole][competency.id]
                            ? simulation.state.competency_comments[this.simulationRole][competency.id]
                            : null
                        return cumulated
                    }, {})
                }
            },

            ratings: {
                deep: true,
                immediate: true,
                handler(ratings) {
                    this.$emit('change', { ratings, comments: this.comments, competencies: this.competencies })
                }
            },

            comments: {
                deep: true,
                immediate: true,
                handler(comments) {
                    this.$emit('change', { ratings: this.ratings, comments, competencies: this.competencies })
                }
            }
        },

        computed: {

            simulationRole() {
                return this.registration.degree['simulation_role_' + this.num]
            },

            competencies() {
                if (!this.simulation['grid' + this.num]) {
                    return []
                }
                return this.simulation['grid' + this.num].competencies
            }
        },

        methods: {

            competencyName(competency) {
                const nameProp = 'name_' + this.registration.degree.lang
                return competency[nameProp]
            },

            competencyDescription(simulation, competencyId) {
                if (!simulation['grid' + this.num]) {
                    return ''
                }
                const competency = simulation['grid' + this.num].competencies.find(competency => competency.id == competencyId)
                if (!competency) {
                    return ''
                }
                return competency.pivot.description
            },

            competencyDomainName(competency) {
                const nameProp = 'name_' + this.registration.degree.lang
                return competency.domain[nameProp]
            },

            ratingChange(competencyId, value) {
                this.ratings[competencyId] = value
                this.$emit('submit')
            },

            commentChange(competencyId, value) {
                this.comments[competencyId] = value
                this.$emit('submit')
            },
        }
    }
</script>

<style scoped>

    .description {
        white-space: pre-wrap;
    }
    .competencies >>> .el-table .rating {
        padding-left: 0;
        padding-right: 0;
    }
    
</style>
